import React from 'react';
import { motion } from 'framer-motion';
interface KpiCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  iconBgColor?: string;
  iconColor?: string;
  delay?: number;
}
export function KpiCard({
  title,
  value,
  icon,
  iconBgColor = 'bg-medical-green-50',
  iconColor = 'text-medical-green',
  delay = 0
}: KpiCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3,
    delay
  }} className="medical-card-hover p-4 md:p-6 flex items-center gap-4" data-id="element-205">
      <div className={`w-10 h-10 md:w-12 md:h-12 shrink-0 rounded-full flex items-center justify-center ${iconBgColor} ${iconColor}`} data-id="element-206">
        {icon}
      </div>
      <div className="min-w-0" data-id="element-207">
        <p className="text-[10px] md:text-small text-text-secondary font-medium uppercase tracking-wider mb-1 truncate" data-id="element-208">
          {title}
        </p>
        <p className="text-2xl md:text-[28px] font-bold text-text-primary leading-none truncate" data-id="element-209">
          {value}
        </p>
      </div>
    </motion.div>;
}